import { AfterViewInit, Component, Inject, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { environment } from "src/environments/environment";
import { helper } from "src/environments/helper";
import { DataTableDirective } from "angular-datatables";
import { HttpClient } from "@angular/common/http";
import { formatDate } from "@angular/common";
import { NotificationService } from "src/app/services/notification.service";
import { finalize, Subject } from "rxjs";
import { PermissionsService } from "src/app/services/permissions.service";
import { DialogService } from "src/app/services/dialog.service";
import { BeneficiariService } from "../../../beneficiari.service";
import { Relationship } from "../../../beneficiari.interface";
import { FormControl, FormGroup } from "@angular/forms";
import { AppFilesService } from "src/app/services/app-files.service";

@Component({
    selector: 'app-view-istoric-relationship',
    templateUrl: './view-istoric-relationship.component.html',
    styleUrls: ['./view-istoric-relationship.component.scss']
})
export class ViewIstoricRelationshipComponent implements OnInit, OnDestroy, AfterViewInit {
    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;
    helper = helper;

    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;

    isLoading = false;
    isEditObs = false;
    editableObs = false;
    originalObservatii = '';

    form: FormGroup = new FormGroup({
        observatii: new FormControl('', []),
    });

    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();
    dtInstance!: DataTables.Api;

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: { row: Relationship, beneficiar_id: number },
        private dialogRef: MatDialogRef<ViewIstoricRelationshipComponent>,
        private dialog: MatDialog,
        private dialogService: DialogService,
        private beneficiariService: BeneficiariService,
        private notificationService: NotificationService,
        private http: HttpClient,
        private appFilesService: AppFilesService,
        public permissionsService: PermissionsService
    ) {
        // Load observatii 
        const relatie = this.data.row;
        const observatii = relatie && relatie.observatii ? relatie.observatii : '';
        this.form.patchValue({ observatii });
        this.originalObservatii = observatii;

        this.editableObs = relatie && !relatie.is_deleted ? true : false;
    }

    ngOnInit(): void {
        this.renderDT();
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }

    ngAfterViewInit(): void {
        this.dtTrigger.next('');
    }

    renderDT() {
        this.dtOptions = {
            responsive: true,
            serverSide: false, // Changed to false since we're using local data
            searching: false,
            pageLength: 10,
            order: [[3, "desc"]],
            data: this.data.row.history, // Use local data instead of ajax
            language: environment.config.romanianLanguageDataTable,
            columns: [
                {
                    title: 'Crt',
                    orderable: true,
                    data: 'id',
                    render: (data: any, type: any, row: any, meta: any) => {
                        return meta.row + 1;
                    },
                },
                {
                    title: 'Utilizator',
                    orderable: true,
                    data: 'id',
                    render: (data: any, type: any, row: any, meta: any) => {
                        return row.user_name ? row.user_name : 'n/a';
                    },
                },
                {
                    title: 'Modificări',
                    orderable: false,
                    data: 'changes',
                    render: (data: Record<string, { label: string; old: string | null; new: string | null }>) => {
                        if (!data || Object.keys(data).length === 0) {
                            return '<span class="text-muted">—</span>';
                        }

                        const rows = Object.entries(data)
                            .map(([index, val]) => {
                                const oldVal = val.old ?? '<em class="text-muted">adăugat</em>';
                                const newVal = val.new ?? '<em class="text-muted">șters</em>';
                                return `
                                <tr>
                                    <td class="fw-semibold pe-3">${val.label}</td>
                                    <td class="text-danger pe-2">${oldVal}</td>
                                    <td class="px-2">→</td>
                                    <td class="text-success">${newVal}</td>
                                </tr>`;
                            })
                            .join('');

                        return `<table>${rows}</table>`;
                    },
                },
                {
                    title: 'Dată',
                    orderable: true,
                    data: 'created_at',
                    render: (data: any, type: any, row: any) => {
                        return row.created_at ? formatDate(row.created_at, 'dd.MM.yyyy HH:mm', 'en-US') : '';
                    },
                },
            ],
            rowCallback: (row: Node, data: any[] | any) => { }
        };
    }

    rerenderDT(resetPaging = false): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw(resetPaging);
        });
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    downloadChanges() {
        this.isLoading = true;
        const fullPath = this.beneficiariService.downloadChangesUrl + `relatie/${this.data.row.id}/${this.data.beneficiar_id}`;

        this.appFilesService.downloadFile(fullPath)
            .then(() => {
                this.isLoading = false;
            })
            .catch(err => {
                console.error('Download doc error: ', err);
                this.isLoading = false;
            })
    }

    // editObs() {
    //     this.isEditObs = true;
    //     this.originalObservatii = this.form.get('observatii')?.value || '';
    // }

    // cancelEditObs() {
    //     this.form.patchValue({ observatii: this.originalObservatii });
    //     this.isEditObs = false;
    // }

    // saveObs() {
    //     if (!this.form.value.observatii) {
    //         this.notificationService.warningSwal(
    //             helper.dialogConfig.headers.errorAtentie,
    //             'Verificați câmpurile introduse',
    //             helper.dialogConfig.icons.warning,
    //         );
    //         return;
    //     }

    //     this.isLoading = true;

    //     const payload = {
    //         observatii: this.form.value.observatii,
    //     };

    //     this.beneficiariService
    //         .updateRelatie(this.data.row.id, payload)
    //         .pipe(finalize(() => (this.isLoading = false)))
    //         .subscribe({
    //             next: (res) => {
    //                 this.dialogRef.close({ success: true });
    //             },
    //             error: (err) => {
    //                 let msg;
    //                 try {
    //                     // try to catch the message from server
    //                     msg = err.error.errors.message[0];
    //                 } catch (error) {
    //                     // controll output message
    //                     msg = helper.dialogConfig.generalMessages.error;
    //                 }
    //                 this.notificationService.warningSwal(
    //                     this.errorTitle,
    //                     msg,
    //                     this.errorIcon
    //                 );
    //             },
    //         });
    // }
}
